import React from "react";
import "./ImageSlider.css";
import Image1 from "./images/image(18).jpg";
import Image2 from "./images/image(17).jpg";
import Image3 from "./images/image(1).jpg";
import Image4 from "./images/image(13).jpg";
import Image5 from "./images/image(3).jpg";
import Image6 from "./images/image(14).jpg";
import Image7 from "./images/image(15).jpg";
import Image8 from "./images/image(16).jpg";

const ImageSlider = () => {
  return (
    <div className="image-grid">
      <div className="image-item">
        <img src={Image1} />
        <div className="text-overlay">
          <p>Floating island with the existence of life in it</p>
        </div>
      </div>
      <div className="image-item">
        <img src={Image2} />
        <div className="text-overlay">
          <p>Beautiful desert in the another dimension</p>
        </div>
      </div>
      <div className="image-item">
        <img src={Image3} />
        <div className="text-overlay">
          <p>A futuristic cyberpunk metropolis</p>
        </div>
      </div>
      <div className="image-item">
        <img src={Image4} />
        <div className="text-overlay">
          <p>An astronaut chilling in tropical savannah</p>
        </div>
      </div>
      <div className="image-item">
        <img src={Image5} />
        <div className="text-overlay">
          <p>Generate a colorful abstract painting</p>
        </div>
      </div>
      <div className="image-item">
        <img src={Image6} />
        <div className="text-overlay">
          <p>Design an otherworldly alien planet with strange plants and creatures</p>
        </div>
      </div>
      <div className="image-item">
        <img src={Image7} />
        <div className="text-overlay">
          <p>An enchanted forest with glowing flora</p>
        </div>
      </div>
      <div className="image-item">
        <img src={Image8} />
        <div className="text-overlay">
          <p>Create a mystical underwater scene with tropical fish and coral reefs</p>
        </div>
      </div>
    </div>
  );
};

export default ImageSlider;
